import * as React from "react";

function SvgCompanies(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 4a1 1 0 11-2 0 1 1 0 012 0zM4 8a1 1 0 100-2 1 1 0 000 2zM5 10a1 1 0 11-2 0 1 1 0 012 0zM5 13a1 1 0 11-2 0 1 1 0 012 0zM4 17a1 1 0 100-2 1 1 0 000 2zM11 14a1 1 0 100-2 1 1 0 000 2zM14 14a1 1 0 100-2 1 1 0 000 2zM14 11a1 1 0 100-2 1 1 0 000 2zM12 10a1 1 0 11-2 0 1 1 0 012 0zM14 8a1 1 0 100-2 1 1 0 000 2zM12 7a1 1 0 11-2 0 1 1 0 012 0z"
        fill="currentColor"
      />
      <path
        d="M11 3v-.75A2.25 2.25 0 008.75 0h-6.5A2.25 2.25 0 000 2.25v16.5c0 .414.336.75.75.75h16.5a.75.75 0 00.75-.75V5.25A2.25 2.25 0 0015.75 3H11zm-9.5-.75a.75.75 0 01.75-.75h6.5a.75.75 0 01.75.75V3h-.25A2.25 2.25 0 007 5.25V18H1.5V2.25zM11.5 18v-1.5h2V18h-2zm3.5-2.25a.75.75 0 00-.75-.75h-3.5a.75.75 0 00-.75.75V18H8.5V5.25a.75.75 0 01.75-.75h6.5a.75.75 0 01.75.75V18H15v-2.25z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgCompanies;
